export default "__VITE_ASSET__DSn8yPVz__"